import React from "react";
import { Carousel } from "react-bootstrap";
import ImgWithPlaceholder from "./ImgWithPlaceholder";
interface ImageCarouselProps {
  imageUrls?: string[];
  alt?: string;
  text?: string;
}
const ImageCarousel: React.FC<ImageCarouselProps> = ({
  imageUrls,
  text,
  alt,
}) => {
  return (
    <Carousel touch={true} controls={true}>
      {imageUrls &&
        imageUrls.length > 0 &&
        imageUrls.map((imageUrl: string, index: number) => (
          <Carousel.Item key={`image_${index}`}>
            <ImgWithPlaceholder
              src={imageUrl}
              alt={text}
              className="product-image"
              fallback={
                <img
                  src="/assets/images/no-image-800x800.png"
                  alt={alt}
                  className="rounded product-image"
                />
              }
            />
            <Carousel.Caption>{text && <h3>{text}</h3>}</Carousel.Caption>
          </Carousel.Item>
        ))}
    </Carousel>
  );
};

export default ImageCarousel;
